// extracted by mini-css-extract-plugin
export var textInput = "_l7-0";